'use client'
import React from 'react';
import Image from 'next/image'

import { qualifyImageUrl } from "@/lib/formatImages";

import Slider from "react-slick";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";

interface ImageCarouselProps {
  items: Object[];
}

const ImageCarousel: React.FC<ImageCarouselProps> = ({ 
  items 
}) => {
  var settings = {
    dots: true,
    infinite: true,
    adaptiveHeight: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  return (
    <div className="mb-2">
      <Slider {...settings}>
        {items.map((item:any) => {
          const imageUrl = qualifyImageUrl(`${item.url}`, 1200, 600);
          if(!imageUrl || imageUrl == '') { return null }
          return <div key={item.sys.id}><Image src={imageUrl} width={1200} height={600} alt="" /></div>
        })}
      </Slider>
    </div>
  );
}

export default ImageCarousel;